import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { turboFrameId: String }

  connect() {
    if (this.hasTurboFrameIdValue) {
      document.querySelectorAll(`turbo-frame#${this.turboFrameIdValue}`)
        .forEach((element) => {
          element.reload()
        })
    }

    this.element.remove()
  }
}
